import React, { useState, useEffect } from 'react';
import ServiceCard from './ServiceCard';
import { servicesData } from './servicesData';
import { Container, Row, Col } from 'reactstrap';
import serviceImage from '../../../assets/images/service-image.jpg';
import StarredImage from './StarredImage';
import useIsMobile from './useIsMobile';
import Button from '../../../components/Button';
import { useNavigate } from 'react-router-dom';

const Services: React.FC = () => {
  const navigate = useNavigate();
  const [activeService, setActiveService] = useState<number>(1);
  const [isAutoRotating, setIsAutoRotating] = useState<boolean>(true);
  const isMobile = useIsMobile(992);
  useEffect(() => {
    if (!isAutoRotating) return;

    const interval = setInterval(() => {
      setActiveService((prev) => (prev === 3 ? 1 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoRotating]);
  const handleServiceClick = (serviceId: number) => {
    setActiveService(serviceId);
    setIsAutoRotating(false);
    setTimeout(() => setIsAutoRotating(true), 10000);
  };

  const currentService =
    servicesData?.find((service) => service.id === activeService) || servicesData[0];
  return (
    <section className="section-gap-lg services-section" data-aos="fade-up">
      <Container>
        {isMobile ? (
          <>
            <div className="services-header mb-3 text-center text-md-start" data-aos="fade-up">
              <h2>Expertise</h2>
              <p className="services-description">
                Our solutions are built to save time, minimize risk, and empower smarter, faster
                decision-making.
              </p>
              <div className="view-services">
                <Button label={'Explore'} onClick={() => navigate('/expertise')} />
              </div>
            </div>

            <div className="services-image mb-3" data-aos="fade-up">
              <StarredImage imageSrc={currentService.image} starPosition="right" />
            </div>
            <div className="service-buttons" data-aos="fade-up">
              {servicesData.map((service) => (
                <div key={service.id}>
                  <button
                    onClick={() => handleServiceClick(service.id)}
                    className={`service-button ${activeService === service.id ? 'active' : ''}`}
                  >
                    <div className="button-content">
                      <div className="button-left">
                        <div className="service-tab-number">
                          <p className="service-number">0{service.id}</p>
                        </div>
                        <div className="service-info">
                          <h3>{service.title}</h3>
                        </div>
                      </div>
                    </div>
                  </button>

                  {activeService === service.id && (
                    <Row className="g-3 mt-2">
                      {service.cards.map((card, index) => (
                        <Col xs="12" key={`${service.id}-${index}`}>
                          <ServiceCard
                            icon={card.icon}
                            title={card.title}
                            description={card.title}
                            delay={index * 100}
                          />
                        </Col>
                      ))}
                    </Row>
                  )}
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            <Row className="">
              <Col lg="6" md="6" xs="12">
                <div className="services-content" data-aos="fade-right">
                  <div className="services-header">
                    <h2>Expertise</h2>
                    <p className="services-description">
                      Our solutions are built to save time, minimize risk, and empower smarter,
                      faster decision-making.
                    </p>
                    <div className="view-services">
                      <Button label={'Explore'} onClick={() => navigate('/expertise')} />
                    </div>
                  </div>
                  <div className="service-buttons">
                    {servicesData.map((service) => (
                      <button
                        key={service.id}
                        onClick={() => handleServiceClick(service.id)}
                        className={`service-button ${activeService === service.id ? 'active' : ''}`}
                      >
                        <div className="button-content">
                          <div className="button-left">
                            <div className="service-tab-number">
                              <p className="service-number">0{service.id}</p>
                            </div>
                            <div className="service-info">
                              <h3>{service.title}</h3>
                            </div>
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </Col>

              <Col lg="6" md="6" xs="12">
                <div className="services-image" data-aos="fade-left">
                  <div className="image-container">
                    <StarredImage imageSrc={currentService.image} starPosition="right" />
                    <div className="image-overlay"></div>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="service-cards">
              <Row className="g-sm-3">
                {currentService.cards.map((card, index) => (
                  <Col
                    xs="12"
                    md="6"
                    lg="4"
                    key={`${activeService}-${index}`}
                    className="pe-3 ps-0 pt-md-3"
                    data-aos="fade-up"
                    data-aos-delay={`${index * 300}`}
                    data-aos-duration="1200"
                  >
                    <ServiceCard
                      icon={card.icon}
                      title={card.title}
                      description={card.title}
                      delay={index * 100}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          </>
        )}
      </Container>
    </section>
  );
};

export default Services;
